import EditBank from "../views/calcsettings/EditBank.vue";
import AddOrEditProduct from "../views/calcsettings/AddOrEditProduct.vue";
import CalculatorTariffs from "../views/calcsettings/CalculatorTariffs.vue";
import BankCalculatorSettings from "../views/BankCalculatorSettings.vue";

const menu = [
  {
    title: "Настройки Банка ",
    icon: "settings",
    url: "/calcsettings",
    meta: { calcAdmin: false, bankir: true },
    id: 8,
  },
];

const routes = [
  {
    path: "/calctariff",
    name: "calctariff",
    component: CalculatorTariffs,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/calcsettings",
    name: "calcsettings",
    component: BankCalculatorSettings,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },

  {
    path: "/editbank",
    name: "editbank",
    component: EditBank,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/editproduct",
    name: "editproduct",
    component: AddOrEditProduct,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
  {
    path: "/addproduct",
    name: "addproduct",
    component: AddOrEditProduct,
    meta: {
      forAuth: true,
      calcAdmin: false,
      bankir: true,
    },
  },
];

export const bank_calc_settings = { menu, routes };
